import { FunctionComponent, HTMLAttributes } from 'react';

const IconNoImage: FunctionComponent<HTMLAttributes<HTMLOrSVGElement>> = (
  props
) => (
  <svg
    {...props}
    viewBox="0 0 34 33"
    fill="none"
    xmlns="https://www.w3.org/2000/svg"
  >
    <title>Image Not Available</title>
    <path
      d="M24.2723 7.05231L22.2246 3.81692C21.7931 3.31385 21.2015 3 20.5385 3H13.4615C12.7985 3 12.2069 3.31385 11.7754 3.81692L9.72769 7.05231C9.29615 7.55615 8.74 7.92308 8.07692 7.92308H3.46154C2.8087 7.92308 2.1826 8.18242 1.72097 8.64405C1.25934 9.10567 1 9.73178 1 10.3846V25.1538C1 25.8067 1.25934 26.4328 1.72097 26.8944C2.1826 27.356 2.8087 27.6154 3.46154 27.6154H30.5385C31.1913 27.6154 31.8174 27.356 32.279 26.8944C32.7407 26.4328 33 25.8067 33 25.1538V10.3846C33 9.73178 32.7407 9.10567 32.279 8.64405C31.8174 8.18242 31.1913 7.92308 30.5385 7.92308H26C25.3346 7.92308 24.7038 7.55615 24.2723 7.05231Z"
      stroke="currentcolor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.9976 22.6925C20.3963 22.6925 23.1514 19.9373 23.1514 16.5386C23.1514 13.1399 20.3963 10.3848 16.9976 10.3848C13.5989 10.3848 10.8438 13.1399 10.8438 16.5386C10.8438 19.9373 13.5989 22.6925 16.9976 22.6925Z"
      stroke="currentcolor"
      strokeMiterlimit="10"
    />
    <path
      d="M6.84615 7.76946V6.07715H5V7.76946"
      stroke="currentcolor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line
      x1="0.646447"
      y1="32.6464"
      x2="32.6464"
      y2="0.646442"
      stroke="currentcolor"
    />
  </svg>
);

export default IconNoImage;
